var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("default-item", {
    staticClass: "menu--item-wv_steak_house_food",
    attrs: { item: _vm.item },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }